import React from 'react';

const RequestRender = (params) => {
    const {data, url} = params;

    return (
        <a href={url + data.id}
           className="w-full h-full text-center mt-2 visited:text-zinc-950 hover:text-zinc-950 text-zinc-950">
            {data.requester}
        </a>
    );
};

export default RequestRender;